<template>
  <v-container class="pt-8 pb-0">
    <!-- Idioma -->
    <v-row>
      <v-select
        :label="t.mdd.idioma"
        append-icon="expand_more"
        item-text="name"
        item-value="cod"
        v-model="mdd.lng"
        :items="langs"
        :rules="[rules.required]"
        @change="cambioLenguaje"
      ></v-select>
    </v-row>
    <!-- País -->
    <v-row class="mt-4">
      <v-select
        :label="t.mdd.versionLit"
        append-icon="expand_more"
        item-text="name"
        item-value="ver"
        v-model="mdd.ver"
        :items="versionesDisp"
        :rules="[rules.required]"
      ></v-select>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "user-libro-mdd",
  props: ["mdd"],
  computed: {
    bookVersions() {
      return this.$store.getters["app/params"].bookVersions;
    },
    versionesDisp() {
      if (this.mdd.lng === "") return [];
      let lng = this.mdd.lng;
      let vers = this.bookVersions.filter(bookVer => {
        return bookVer.lng === lng && bookVer.ver !== "";
      });

      return vers;
    },
    langs() {
      return this.$store.getters["app/params"].langs;
    },
    rules() {
      return {
        required: value => !!value || "Esta información es obligatoria."
      };
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    }
  },
  methods: {
    cambioLenguaje() {
      if (this.versionesDisp.length === 1) {
        this.mdd.ver = this.versionesDisp[0].ver;
      } else {
        this.mdd.ver = "";
      }
    }
  }
};
</script>
